import { StaticCanvas } from 'fabric';
import type { Canvas } from 'fabric';
import type { CanvasJSON } from '../../canvas/types';
import { prepareCanvasJson } from '../../canvas/utils/prepare-canvas-json';
import type { PieceModel } from '../types';
import { fabricToModel } from './fabric-to-model';
import { pieceReducer } from '../piece-reducer';
import { normalizeModel } from '../normalize';

type Piece = { width: number; height: number; type: 'image' | 'video' };

export const canvasJsonToModel = async (json: CanvasJSON, piece: Piece): Promise<PieceModel> => {
  const offscreen = new StaticCanvas(undefined, { width: piece.width, height: piece.height });
  try {
    await offscreen.loadFromJSON(await prepareCanvasJson(json));
    const visual = fabricToModel(offscreen as unknown as Canvas, piece);
    // Audio is not a canvas object: it travels beside the objects and sets the piece duration.
    const model = pieceReducer(visual, { type: 'setAudioLayers', layers: json.audioLayers ?? [] });
    return normalizeModel(model);
  } finally {
    offscreen.dispose();
  }
};
